import React from 'react'
import { FaDiscord } from 'react-icons/fa';
import { FaTelegram, FaXTwitter, FaFacebook } from 'react-icons/fa6';
import { useNavigate } from '../../hook/useNavigate';

const socialLinks = [
    {
        goTo: "https://t.me/ztpoker",
        icon: <FaTelegram />,
    },
    {
        goTo: "https://discord.gg/Y3ncVAeuqc",
        icon: <FaDiscord />,
    },
    {
        goTo: "https://x.com/ZeroTrustPoker",
        icon: <FaXTwitter />,
    },
    {
        goTo: "https://www.facebook.com/ZTPoker",
        icon: <FaFacebook />,
    },
];

const FAQ = () => {
    const { navNewTab } = useNavigate();

    return (
        <div id='faq' className="faq-area">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="faq-content">
                            <h2 className="text-center top-reveal">
                                FAQ
                            </h2>
                            <div className="faq-contianer top-reveal">
                                <h3>What is Zero Trust Poker?</h3>
                                <p>Zero Trust Poker is a decentralized, provably fair online poker platform that eliminates the need to trust a central authority.</p>
                            </div>

                            <div style={{ marginTop: '20px' }} className="faq-contianer top-reveal">
                                <h3>How do I participate in the Beta testing?</h3>
                                <p>Please join one of our social channels and stay tuned for launch announcements.</p>
                                <div className="header-social">
                                    <div style={{ display: 'flex' }}>
                                        {socialLinks.map((item, index) => (
                                            <div key={index} className="nav-social" style={{ cursor: 'pointer' }} onClick={() => navNewTab(item.goTo)}>
                                                {item.icon}
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>

                            <div style={{ marginTop: '20px' }} className="faq-contianer top-reveal">
                                <h3>What cryptocurrencies does Zero Trust Poker support?</h3>
                                <p>The platform will support the newly launched ZTGM (Zero Trust Gaming) Token.</p>
                            </div>

                            <div style={{ marginTop: '20px' }} className="faq-contianer top-reveal">
                                <h3>Is my balance secured on the platform?</h3>
                                <p>Yes, funds are stored in non-custodial wallets, and smart contracts handle transactions securely, ensuring no central control over player balances.</p>
                            </div>

                            <div style={{ marginTop: '20px', marginBottom: '40px' }} className="faq-contianer top-reveal">
                                <h3>When is the official launch of Zero Trust Poker?</h3>
                                <p>Zero Trust Poker Beta will launch on May 3rd 2025. Official launch and token fair offering will follow 3-4 months after.</p>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default FAQ